import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f689842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { style: {"font-weight":"700","padding":"0.16rem 3%","font-size":"20px"} }
const _hoisted_5 = { class: "card-value" }
const _hoisted_6 = { style: {"font-weight":"700","padding":"0.16rem 3% 0","font-size":"16px","align-items":"flex-start"} }
const _hoisted_7 = { class: "card-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background-color":"#e3f2ff","height":"0.8rem","text-align":"center","font-weight":"bolder","display":"flex","justify-content":"center","align-items":"center"} }, " <项目整体进度> ", -1))
const _hoisted_9 = { class: "card" }
const _hoisted_10 = ["ganttData", "index"]
const _hoisted_11 = { style: {"margin-top":"10px","/*background-color":"#f2f2f2","*/\n                padding":"10px","border-radius":"5px"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"display":"flex","align-items":"center","margin-bottom":"10px"} }
const _hoisted_14 = { style: {"margin-left":"5px"} }
const _hoisted_15 = { style: {"display":"flex","align-items":"flex-start"} }
const _hoisted_16 = { style: {"font-weight":"900","display":"inline-block","padding-right":"5px","font-size":"16px","color":"#dd5466","margin-right":"7px","max-width":"4.2rem","word-wrap":"break-word"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "阶段目标", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时间：", -1))
const _hoisted_21 = { class: "timeColor" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { style: {"display":"flex","align-items":"flex-start"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1))
const _hoisted_25 = { style: {"display":"inline-block","max-width":"60%","word-wrap":"break-word","margin-left":"0.2rem","font-weight":"bolder"} }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  style: {"background-color":"#f0f0f0","margin":"10px","border-radius":"5px","padding":"7px"}
}
const _hoisted_28 = { key: 0 }

import { reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { Col, Divider, Empty, Icon, Loading, Overlay, Row } from "vant";
import dayjs from "dayjs";
import request, { downloadURL } from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'development1',
  setup(__props) {

const route = useRoute();
const visible = ref(false);
const pageData = ref<any>();
const stateDevelopmentList = ref<any>([]);

let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/incubate/statics?time=" + time,
    method: "GET",
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
// getPageData();
const params = reactive({
  currentPage: 1,
  pageSize: 1,
});
const total = ref(0);
const productName = ref();
const overallTarget = ref();
const projectProgress = ref();
const copyStateDevelopmentList = ref();
const getList = async () => {
  const res = await request({
    url: "/api/wx/incubate/list",
    method: "POST",
    data: {
      endCreateTime: time + " 23:59:59",
      status: 1,
      productName: route?.params.productName,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    window.document.title = res.data[0].productName;
    productName.value = res.data[0].productName;
    overallTarget.value = res.data[0].overallTarget;
    projectProgress.value = res.data[0].projectProgress;
    const data =
      res.data.map((item) => {
        return {
          ...item,
          progressList: item.progressList ? item.progressList : [],
        };
      }) || [];
    copyStateDevelopmentList.value = JSON.parse(JSON.stringify(data));
    stateDevelopmentList.value = JSON.parse(JSON.stringify(data));

    total.value = res.data.total;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getList();
const handleChange = (value: any) => {
  params.currentPage = value;
  getList();
};
const handleDown = (item: any) => {
  downloadURL({
    url: "/api/wx/incubate/downloads",
    method: "POST",
    data: {
      path: item.fileUrl,
      fileName: item.fileName,
    },
    // headers: {
    //   openId: sessionStorage.getItem("openid"),
    // },
  });
};
const showBottom = ref(false);
const progressList = ref([]);
const incubateId = ref();
const clickAlljd = (value: any, id: any) => {
  showBottom.value = true;
  progressList.value = value;
  incubateId.value = id;
};
const handleClickView = (value: any) => {
  stateDevelopmentList.value.forEach((item) => {
    if (item.incubateId == incubateId.value) {
      item.showProgressList = [value];
    }
    return item;
  });
  showBottom.value = false;
  incubateId.value = "";
};
const clickViewNow = () => {
  stateDevelopmentList.value = JSON.parse(
    JSON.stringify(copyStateDevelopmentList.value)
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      (!stateDevelopmentList.value.length)
        ? (_openBlock(), _createBlock(_unref(Empty), {
            key: 0,
            description: "暂无数据",
            "image-size": "100"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Row), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Col), { span: "8" }, {
                    default: _withCtx(() => [
                      _createTextVNode("项目名称：")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Col), { span: "16" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(productName.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Row), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Col), { span: "8" }, {
                    default: _withCtx(() => [
                      _createTextVNode("项目总目标：")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Col), { span: "16" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(overallTarget.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(Row), { style: {"display":"flex","font-weight":"700","padding":"0.16rem 3% 0","font-size":"16px","align-items":"flex-end"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Col), { span: "8" }, {
                    default: _withCtx(() => [
                      _createTextVNode("项目进度：")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Col), { span: "16" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(projectProgress.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stateDevelopmentList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"position":"relative"},
                key: index
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (item.progressList && item.progressList.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ganttData: item.progressList,
                        index: index
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    (item.progressList && item.progressList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.progressList, (children, childrenIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: childrenIndex }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({
                        one: childrenIndex == 0,
                        two: childrenIndex == 1,
                        three: childrenIndex == 2,
                        other: childrenIndex > 2,
                      })
                                }, _toDisplayString(childrenIndex + 1), 3),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("span", _hoisted_16, [
                                      _hoisted_17,
                                      _createElementVNode("span", null, _toDisplayString(childrenIndex + 1), 1),
                                      _createTextVNode("： " + _toDisplayString(children.stageObjective), 1)
                                    ]),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(
                            children.status == '已完成'
                              ? 'finished'
                              : children.status == '进行中'
                              ? 'underway'
                              : 'otherText'
                          ),
                                      style: {"display":"inline-block","margin-top":"3px"}
                                    }, _toDisplayString(children.status), 3),
                                    _createElementVNode("span", {
                                      style: {"position":"absolute","right":"0","margin-right":"0.4rem"},
                                      onClick: ($event: any) => (children.showFlag = !children.showFlag)
                                    }, [
                                      (children.showFlag)
                                        ? (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 0,
                                            name: "arrow-up"
                                          }))
                                        : _createCommentVNode("", true),
                                      (!children.showFlag)
                                        ? (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 1,
                                            name: "arrow-down"
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_18)
                                  ]),
                                  (children.startDay)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(children.startDay) + " 到 " + _toDisplayString(children.endDay), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (children.showFlag)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.progressResponseList, (childrenTwo, childrenTwoIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: childrenTwoIndex,
                                        style: {"margin-top":"5px"}
                                      }, [
                                        _createElementVNode("div", _hoisted_23, [
                                          _hoisted_24,
                                          _createElementVNode("span", _hoisted_25, _toDisplayString(childrenTwo.specificAction), 1),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(
                            childrenTwo.status == '已完成'
                              ? 'finished'
                              : childrenTwo.status == '进行中'
                              ? 'underway'
                              : 'otherText'
                          ),
                                            style: {"position":"absolute","right":"1.4rem"}
                                          }, _toDisplayString(childrenTwo.status), 3),
                                          _createElementVNode("span", {
                                            style: {"position":"absolute","right":"0","margin-right":"1rem"},
                                            onClick: ($event: any) => (childrenTwo.showFlag = !childrenTwo.showFlag)
                                          }, [
                                            (childrenTwo.showFlag)
                                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                                  key: 0,
                                                  name: "arrow-up"
                                                }))
                                              : _createCommentVNode("", true),
                                            (!childrenTwo.showFlag)
                                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                                  key: 1,
                                                  name: "arrow-down"
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_26)
                                        ]),
                                        (childrenTwo.showFlag)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                              _createElementVNode("p", null, _toDisplayString(childrenTwo.nodeProgress), 1),
                                              _createElementVNode("p", null, "负责人：" + _toDisplayString(childrenTwo.superintendent), 1),
                                              _createElementVNode("p", null, " 时间： " + _toDisplayString(childrenTwo.nodeStartDay) + "  到  " + _toDisplayString(childrenTwo.nodeEndDay), 1),
                                              (childrenTwo.remark)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_28, " 备注：" + _toDisplayString(childrenTwo.remark), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    (
                        item.progressList.length > 1 &&
                        childrenIndex < item.progressList.length - 1
                      )
                                      ? (_openBlock(), _createBlock(_unref(Divider), {
                                          key: 0,
                                          style: { borderColor: '#DFDFDF' }
                                        }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ], 64))
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})